// Currently only 6 steps max, if more are needed just add one more at the end of this file.
// Call your observer by step number: observer1, observer2...
export const formStepsMixin = {
  data () {
    return {
      // Override steps variable in the main component
      steps: 0,
      activeStep: 0
    }
  },
  computed: {
    onFirstStep () {
      return this.activeStep === 0
    },
    onLastStep () {
      return this.activeStep === this.steps - 1
    }
  },
  methods: {
    previousStep () {
      let newStep = this.activeStep - 1
      this.activeStep = newStep > 0 ? newStep : 0
    },
    nextStep () {
      if (this.activeStep === 0) {
        if (this.$refs.observer1) {
          this.$refs.observer1.validate().then((success) => {
            if (success) {
              let newStep = this.activeStep + 1
              this.activeStep = newStep < this.steps - 1 ? newStep : this.steps - 1
            }
          })
        } else {
          let newStep = this.activeStep + 1
          this.activeStep = newStep < this.steps - 1 ? newStep : this.steps - 1
        }
      } else if (this.activeStep === 1) {
        if (this.$refs.observer2) {
          this.$refs.observer2.validate().then((success) => {
            if (success) {
              let newStep = this.activeStep + 1
              this.activeStep = newStep < this.steps - 1 ? newStep : this.steps - 1
            }
          })
        } else {
          let newStep = this.activeStep + 1
          this.activeStep = newStep < this.steps - 1 ? newStep : this.steps - 1
        }
      } else if (this.activeStep === 2) {
        if (this.$refs.observer3) {
          this.$refs.observer3.validate().then((success) => {
            if (success) {
              let newStep = this.activeStep + 1
              this.activeStep = newStep < this.steps - 1 ? newStep : this.steps - 1
            }
          })
        } else {
          let newStep = this.activeStep + 1
          this.activeStep = newStep < this.steps - 1 ? newStep : this.steps - 1
        }
      } else if (this.activeStep === 3) {
        if (this.$refs.observer4) {
          this.$refs.observer4.validate().then((success) => {
            if (success) {
              let newStep = this.activeStep + 1
              this.activeStep = newStep < this.steps - 1 ? newStep : this.steps - 1
            }
          })
        } else {
          let newStep = this.activeStep + 1
          this.activeStep = newStep < this.steps - 1 ? newStep : this.steps - 1
        }
      } else if (this.activeStep === 4) {
        if (this.$refs.observer5) {
          this.$refs.observer5.validate().then((success) => {
            if (success) {
              let newStep = this.activeStep + 1
              this.activeStep = newStep < this.steps - 1 ? newStep : this.steps - 1
            }
          })
        } else {
          let newStep = this.activeStep + 1
          this.activeStep = newStep < this.steps - 1 ? newStep : this.steps - 1
        }
      } else if (this.activeStep === 5) {
        if (this.$refs.observer6) {
          this.$refs.observer6.validate().then((success) => {
            if (success) {
              let newStep = this.activeStep + 1
              this.activeStep = newStep < this.steps - 1 ? newStep : this.steps - 1
            }
          })
        } else {
          let newStep = this.activeStep + 1
          this.activeStep = newStep < this.steps - 1 ? newStep : this.steps - 1
        }
      }
    }

  }
}
